import React from 'react';
import { FilterSearchIconComponent } from '../component/FilterSearchIconComponent/FilterSearchIconComponent';

export const SearchIcon = (isFiltered: boolean) => (
  <FilterSearchIconComponent isFiltered={isFiltered} />
);
